import { BulkProductPriceModel } from './bulkProductPriceModel';

export class BulkProductModel{
    id:number;
    title:string;
    displayVersion:string;
    name:string;
    downloadcount:number;
    description:string;
    tagline:string;
    size:number;
    features:string;
    isFeatured:boolean;
    prices:BulkProductPriceModel[];
}